import { CIcon } from '~/icons/types'

export const ciSubtract: CIcon = {
  width: '20',
  height: '20',
  paths: [
    {
      d:
        'M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm5.955-4.83a.6.6 0 0 0-.13-.194L10.849 10l4.976-4.975a.6.6 0 1 0-.849-.849l-4.975 4.976-4.976-4.976a.6.6 0 0 0-.849.849L9.152 10l-4.976 4.976a.6.6 0 0 0 .85.849L10 10.849l4.975 4.976a.6.6 0 0 0 .98-.654Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'subtract',
  type: 'regular'
}
